import {h, Fragment} from "preact"
import { useResponse, useAppStateSelector } from "@nosto/preact"
import { mapSearchProducts } from "../helpers"
import SearchResultsPanel from "./SearchResultsPanel"
import { useSearchQuery } from "../hooks"
import { settings } from "../config"

export default function Autocomplete() {
    const { products, keywords } = useResponse()
    const {loading} = useAppStateSelector(state => state)
    const {searchQuery} = useSearchQuery();
    const defaultProducts = (settings?.search_product_list || [])?.slice(0, 4);
    const mappedProducts = searchQuery ? mapSearchProducts(products.hits) : defaultProducts;

    return (
        <SearchResultsPanel 
            products={mappedProducts} 
            keywords={keywords?.hits} 
            searchQuery={searchQuery}
            total={products?.total}
            loading={loading} />
        )
}

